import { createApp } from 'vue'
import App from './App.vue'
import i18n from './locales'
// import router from './router'
import router from './router'
import pinia from './stores'
import TDesign from 'tdesign-vue-next';
import '@/assets/styles/main.css'
import 'virtual:uno.css'
const app = createApp(App)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(TDesign);
app.mount('#app')
